var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.field.label,"rules":_vm.field.rules,"hide-details":"auto"},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}}),_c('input',{attrs:{"type":"hidden","name":_vm.field.name},domProps:{"value":_vm.field.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }